let number = 0;

// Session-unique number source: one module-scoped counter shared by every
// importer, yielding strictly increasing consecutive integers — each call
// returns a value never returned before in this JS realm. The counter lives
// for the page lifetime and deliberately never resets (not per-user state,
// so no auth-lifecycle reset applies): the values are fit only for ephemeral
// in-session identity — React ids, cache-busting key suffixes — where only
// within-session collision matters; consumers must never persist them or
// rely on them across reloads. Values are predictable sequential integers;
// never use them for anything security-sensitive.
export function getUniqueNumber(): number {
  return number++;
}
